import { render, staticRenderFns } from "./ChangeBestReview.vue?vue&type=template&id=0f64a896&"
import script from "./ChangeBestReview.vue?vue&type=script&lang=ts&"
export * from "./ChangeBestReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports